import { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FULLY_TRANSLATED } from '../i18n/strings';

export default function LanguageSelector() {
  const { lang, setLang, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = languages.find((l) => l.code === lang) || languages[0];

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const choose = (code) => {
    setLang(code);
    setOpen(false);
  };

  return (
    <div className="lang" ref={ref}>
      <button
        type="button"
        className="lang__btn"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Select language"
        onClick={() => setOpen((o) => !o)}
      >
        <svg className="lang__globe" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c2.5 2.6 2.5 15.4 0 18M12 3c-2.5 2.6-2.5 15.4 0 18" />
        </svg>
        <span>{current.label}</span>
        <svg className={`lang__caret ${open ? 'is-open' : ''}`} viewBox="0 0 10 6" width="9" height="6" aria-hidden>
          <path d="M0 0l5 6 5-6z" fill="currentColor" />
        </svg>
      </button>

      {open && (
        <ul className="lang__menu" role="listbox" aria-label="Languages">
          {languages.map((l) => (
            <li key={l.code} role="option" aria-selected={l.code === lang}>
              <button
                type="button"
                className={`lang__item ${l.code === lang ? 'is-active' : ''}`}
                onClick={() => choose(l.code)}
              >
                <span>{l.label}</span>
                {l.code === lang ? (
                  <span className="lang__check" aria-hidden>✓</span>
                ) : (
                  !FULLY_TRANSLATED.includes(l.code) && <span className="lang__soon">soon</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
